import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchAvailableParents } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";

const useFetchAvailableParents = (
  companyId: string,
  structureId: string | undefined,
  areaId: string | undefined,
  query?: string
) => {
  const normalizedQuery = query?.trim();
  const filters = normalizedQuery
    ? `(${normalizedQuery
        .split(/\s+/)
        .map((word) => `areaName=like=*${word}*`)
        .join(";")})`
    : null;
  return useInfiniteQuery({
    enabled: !!companyId && !!structureId && !!areaId,
    queryKey: [
      "fetch-available-parents",
      companyId,
      structureId,
      areaId,
      query,
    ],
    queryFn: async ({ pageParam, signal }) => {
      const data = await fetchAvailableParents(
        companyId,
        structureId!,
        areaId!,
        {
          signal,
          nextCursor: pageParam,
          query: filters,
        }
      );
      return data;
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor || null,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchAvailableParents;
